var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquare6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 70,
    viewBox: "0 0 106 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8274 3.05458C17.8274 3.05458 22.6262 2.09094 26.0183 2.09094C29.4104 2.09094 34.2092 3.05458 34.2092 3.05458",
    stroke: "#F58634",
    strokeWidth: 2.89091,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8091 3.05458C44.8091 3.05458 49.6079 2.09094 53 2.09094C56.3921 2.09094 61.1909 3.05458 61.1909 3.05458",
    stroke: "#F58634",
    strokeWidth: 2.89091,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.791 3.05458C71.791 3.05458 76.5898 2.09094 79.9819 2.09094C83.3741 2.09094 88.1728 3.05458 88.1728 3.05458",
    stroke: "#F58634",
    strokeWidth: 2.89091,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39642 9.98649C2.6736 8.18625 4.19315 6.85913 6.01326 6.7893L53.1297 4.98181L100.198 6.78744C102.04 6.85811 103.571 8.21549 103.826 10.041C104.58 15.4282 106 26.6391 106 34.627C106 42.6292 104.575 53.8658 103.822 59.2418C103.568 61.0544 102.056 62.4072 100.228 62.4939L53.1297 64.7273L5.9833 62.4916C4.17695 62.406 2.67614 61.083 2.40076 59.2957C1.57604 53.943 0 42.6628 0 34.627C0 26.6054 1.57053 15.3505 2.39642 9.98649Z",
    fill: "#A098AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1729 66.6546C88.1729 66.6546 83.3741 67.6182 79.9819 67.6182C76.5898 67.6182 71.791 66.6546 71.791 66.6546",
    stroke: "#F58634",
    strokeWidth: 2.89091,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1909 66.6546C61.1909 66.6546 56.3921 67.6182 53 67.6182C49.6079 67.6182 44.8091 66.6546 44.8091 66.6546",
    stroke: "#F58634",
    strokeWidth: 2.89091,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2092 66.6546C34.2092 66.6546 29.4105 67.6182 26.0183 67.6182C22.6262 67.6182 17.8274 66.6546 17.8274 66.6546",
    stroke: "#F58634",
    strokeWidth: 2.89091,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare6);
export default __webpack_public_path__ + "static/media/square6.bf90292200d2ae0d4f8ec4984f173251.svg";
export { ForwardRef as ReactComponent };